import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'
import AppEvents from "./eventBus";
export default {
  install (Vue) {
    // use a new Vue instance as the interface for Vue components to receive/send SignalR events
    // this way every component can listen to events or send new events using this.$questionHub
    const loginHub = new Vue()
    Vue.prototype.$loginHub = loginHub

    // Provide methods to connect/disconnect from the SignalR hub
    let connection = null
    let startedPromise = null
    let manuallyClosed = false

    Vue.prototype.startSignalR = (jwtToken) => {
      connection = new HubConnectionBuilder()
        .withUrl(
          `${Vue.prototype.$http.defaults.baseURL}login-hub`,
          jwtToken ? { accessTokenFactory: () => jwtToken } : null
        )
        .configureLogging(LogLevel.Information)
        .build()

      // Forward hub events through the event, so we can listen for them in the Vue components
    
      connection.on('ReplyDoLogin', (username, text) => {
           
            if(username == localStorage.getItem("userSignalR") && text == localStorage.getItem("clienteid"))
            {
                
                AppEvents.$emit("APP_LOGOUT_MULTIPLE");
            }

       
      })

      connection.on('UpdateDashboard', (codigo,accion) => {
           
        
            
            AppEvents.$emit("APP_REFRESH_DASHBOARD",{codigo,accion});
         

   
  })

      // You need to call connection.start() to establish the connection but the client wont handle reconnecting for you!
      // Docs recommend listening onclose and handling it there.
      // This is the simplest of the strategies
      function start () {
        startedPromise = connection.start()
          .catch(err => {
            console.error('Failed to connect with hub', err)
            return new Promise((resolve, reject) => setTimeout(() => start().then(resolve).catch(reject), 5000))
          })
        return startedPromise
      }
      connection.onclose(() => {
        if (!manuallyClosed) start()
      })

      // Start everything
      manuallyClosed = false
      start()
    }
    Vue.prototype.stopSignalR = () => {
      if (!startedPromise) return

      manuallyClosed = true
      return startedPromise
        .then(() => connection.stop())
        .then(() => { startedPromise = null })
    }
    Vue.prototype.isConnected = () => {

        return connection;
       }
     
    loginHub.sendMessage = (group, message) => {
      if (!startedPromise) return

      return startedPromise
        .then(() => connection.invoke('SendDoLogin' ,group, message))
        .catch(console.error)
    }
  }
}
